import { FETCH_BATCH_LABEL_FILE_SUCCESS, FETCH_BATCH_LABEL_FILE_REQUEST, FETCH_BATCH_LABEL_FILE_FAILURE, FETCH_BATCH_LABEL_FILE_REST, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const downloadBatchLabelReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_BATCH_LABEL_FILE_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case FETCH_BATCH_LABEL_FILE_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case FETCH_BATCH_LABEL_FILE_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case FETCH_BATCH_LABEL_FILE_REST:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default downloadBatchLabelReducer;
